angular
  .module('contributor')

  .directive('contributorActivationButton', [
    '$controller',
    '$filter',
    function($controller, $filter) {
      return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: true,
        template:
          '<a href="" class="pv-follow-btn btn-success" ng-class="active ? \'btn-success\' : \'btn-danger\'" ng-transclude></a>',
        controller: [
          '$scope',
          '$element',
          'Confirm',
          'ContributorStore',
          'ContributorActivation',
          function(
            $scope,
            $element,
            Confirm,
            ContributorStore,
            ContributorActivation
          ) {
            var confirm = new Confirm();

            ContributorStore.listenTo(function(contributor) {
              $scope._id = contributor ? contributor._id : null;
              $scope.active = contributor ? !!contributor.active : false;
            });

            $controller('EditBaseCtrl', {
              $scope: $scope,
              crud: new ContributorActivation(),
              object: null,
              packageName: 'active',
              dataName: 'activeObj',
              formName: 'activeForm'
            });

            $element.click(function() {
              var active = $scope.active;
              confirm
                .info(
                  $filter('translate')(
                    active
                      ? 'contributors.ASK_DEACTIVE'
                      : 'contributors.ASK_ACTIVE'
                  )
                )
                .then(function() {
                  $scope.activeObj = {
                    _id: $scope._id,
                    active: !active
                  };

                  $scope.processSaving().then(function() {
                    $scope.active = !active;
                    ContributorStore.emitActive($scope.active);
                  });
                });
            });
          }
        ]
      };
    }
  ]);
